import React from 'react';
import { motion } from 'framer-motion';
import logo from '../assets/images/logo-transparent-png.png';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <div className="about-content">
          <motion.div 
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="about-title-wrapper">
              <h2>À Propos de Drive Inter</h2>
          
            </div>
            <p className="highlight">Une expertise reconnue au service de votre réussite</p>
            <p>
Notre objectif est de mettre en œuvre les moyens les plus optimaux du métier, en connaissant les risques
et les complications éventuels. Nous mettons à votre
disposition notre organisation, notre savoir-faire, notre sérieux, et un service client à votre écoute. Notre équipe est spécialisée pour le transport de
marchandises afin de vous apporter une réelle garantie de travail réussi
            </p>
           
            <div className="stats">
              <motion.div 
                className="stat-item"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.2 }}
                viewport={{ once: true }}
              >
                <span className="stat-number">53+</span>
                <span className="stat-label">Clients Satisfaits</span>
              </motion.div>
              <motion.div 
                className="stat-item"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.4 }}
                viewport={{ once: true }}
              >
                <span className="stat-number">13+</span>
                <span className="stat-label">Années d'Expérience</span>
              </motion.div>
              <motion.div 
                className="stat-item"
                initial={{ opacity: 0, scale: 0.5 }}
                whileInView={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.5, delay: 0.6 }}
                viewport={{ once: true }}
              >
                <span className="stat-number">98%</span>
                <span className="stat-label">Taux de Satisfaction</span>
              </motion.div>
            </div>
          </motion.div>
          <motion.div 
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
          >
            <div className="image-placeholder">
              <img src={logo} alt="Drive Inter" className="about-main-logo" />
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default About;
